<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1">F<span class="smallcaps">IGURES</span></h1>
<table>
<tbody>
<tr>
<td class="td1">
<p class="t-left"><span href="#/012_Chapter02#fig1" title="Link target outside of Sample"><strong>Figure 1</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/012_Chapter02#fig1" title="Link target outside of Sample">An “elephant tree” (marula tree, <em>Sclerocarya birrea</em>) in the shape of the actual animal</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/013_Chapter03#fig2" title="Link target outside of Sample"><strong>Figure 2</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/013_Chapter03#fig2" title="Link target outside of Sample">Claudius defeating Britannia, in a relief from the Sebasteion in Aphrodisias</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/013_Chapter03#fig3" title="Link target outside of Sample"><strong>Figure 3</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/013_Chapter03#fig3" title="Link target outside of Sample">Latin inscription including the words SACERDOTI VICTORIAE | BRITANN</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig4" title="Link target outside of Sample"><strong>Figure 4</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig4" title="Link target outside of Sample">The <em>Laus Caesaris</em>, a song praising Claudius after his return from Britannia</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig5" title="Link target outside of Sample"><strong>Figure 5</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig5" title="Link target outside of Sample">Inscription from the Arch of Claudius, Rome</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig6" title="Link target outside of Sample"><strong>Figure 6</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig6" title="Link target outside of Sample">Drawing of the Arch of Claudius, Rome</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig7" title="Link target outside of Sample"><strong>Figure 7</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig7" title="Link target outside of Sample">Cameo showing Augustus as Alexander-Zeus</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig8" title="Link target outside of Sample"><strong>Figure 8</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig8" title="Link target outside of Sample">The Great/Hague Cameo, showing an emperor with his family on the triumphal chariot</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig9" title="Link target outside of Sample"><strong>Figure 9</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig9" title="Link target outside of Sample">A Roman <em>aureus</em>; the reverse depicts Vespasian on the triumphal chariot and a captive being led by a soldier before him</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig10" title="Link target outside of Sample"><strong>Figure 10</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig10" title="Link target outside of Sample">The Claudian table, which preserves a speech of Claudius before the Roman senate</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig11" title="Link target outside of Sample"><strong>Figure 11</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig11" title="Link target outside of Sample">Claudius with figures representing land and sea, in a relief from the Sebasteion in Aphrodisias</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig12" title="Link target outside of Sample"><strong>Figure 12</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig12" title="Link target outside of Sample">The triumph of Bacchus with echoes of the Roman ritual, on a sarcophagus at the Villa Medici</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig13" title="Link target outside of Sample"><strong>Figure 13</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig13" title="Link target outside of Sample">Cameo showing Augustus in a chariot drawn by Tritons</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/014_Chapter04#fig14" title="Link target outside of Sample"><strong>Figure 14</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/014_Chapter04#fig14" title="Link target outside of Sample">Arch of Titus, Rome</span></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left"><span href="#/015_Chapter05#fig15" title="Link target outside of Sample"><strong>Figure 15</strong></span></p></td>
<td class="td2">
<p class="t-left"><span href="#/015_Chapter05#fig15" title="Link target outside of Sample">Alexamenos graffito, Rome, ca. 200 CE</span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Figures.vue?5cb4f518